import { NavLink } from 'react-router';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ImageWrapper = styled.div`
	width: 100%;
	height: 250px;
	padding: 4px 4px 0;
`;

export const Image = styled.img`
	width: 100%;
	height: 100%;
	border-radius: 8px;

	object-fit: cover;
	object-position: right;
`;

export const UpperSection = styled.div`
	padding: 12px 4px 12px;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light15};
`;

export const DatePrizeRow = styled.div`
	display: flex;
	gap: 8px;
`;

export const DatePrizeText = styled.div`
	font-size: 16px;
	line-height: 22px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	display: flex;
	gap: 4px;
	align-items: center;
`;

export const CalendarIconWrapper = styled.div`
	width: 18px;
	height: 18px;
	display: flex;
	align-items: center;

	svg {
		mask {
			rect {
				fill: ${({ theme }) => theme.colors.icon.chevron};
			}
		}

		path {
			fill: ${({ theme }) => theme.colors.icon.chevron};
		}
	}
`;

export const Congrats = styled.div`
	margin-bottom: 16px;

	font-size: 24px;
	line-height: 33px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};

	display: flex;
	align-items: center;
	gap: 4px;
`;

export const PartyPopperWrapper = styled.div`
	width: 24px;
	height: 24px;
`;

export const PartyPopper = styled.img`
	width: 100%;
	height: 100%;
`;

export const LowerSection = styled.div`
	padding: 12px 4px 0;
`;

export const Description = styled.p`
	font-size: 16px;
	line-height: 22px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.body};
	margin-bottom: 16px;
`;

export const SupportLinks = styled.div`
	display: flex;
	gap: 8px;
`;

export const HelpIconWrapper = styled.div`
	width: 20px;
	height: 20px;

	display: flex;
	align-items: center;

	svg {
		width: 20px;
		height: 20px;

		path {
			fill: ${({ theme }) => theme.colors.text.alwaysWhite};
		}
	}
`;

export const HelpButton = styled(NavLink)<{ $isTelegram?: boolean }>`
	padding: 8px;
	background-color: ${({ theme }) => theme.colors.control.dark};
	border-radius: 11px;

	font-size: 14px;
	line-height: 22px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	display: flex;
	align-items: center;
	gap: 4px;

	${({ $isTelegram }) =>
		$isTelegram &&
		css`
			background-color: #299fda;
		`}
`;

export const ButtonRow = styled.div`
	padding: 20px 4px 4px;

	width: 100%;
	display: flex;
	justify-content: flex-end;
`;
